import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ProfileModal from './ProfileModal';
import { addRecruiterWishlist, getProfileByEmail, removeRecruiterWishlist } from '../../../redux/actions/halloffame';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';

const CandidatesCard = ({ key, candidates, isWishlisted, onLogin, matchScore }) => {

    const dispatch = useDispatch();
    const [fullProfile, setFullProfile] = useState({});
    const [isFetchingFullProfile, setIsFetchingFullProfile] = useState(false);
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const recruiterAccessToken = useSelector((store) => store?.hallOfFame?.recruiterAccessToken);
    const [isWishlistedLocal, setIsWishlistedLocal] = useState(isWishlisted);

    useEffect(() => {
        setIsWishlistedLocal(isWishlisted);
    }, [isWishlisted]);

    const getInitials = (fullName) => {
        const normalizedName = (fullName || '').trim();
        if (!normalizedName) return 'NA';
        const nameParts = normalizedName.split(/\s+/).filter(Boolean);
        if (!nameParts.length) return 'NA';
        if (nameParts.length === 1) return nameParts[0].slice(0, 2).toUpperCase();
        return `${nameParts[0][0] || ''}${nameParts[1][0] || ''}`.toUpperCase();
    };

    const checkIfLoggedIn = () => {
        if (!recruiterAccessToken) {
            onLogin();
            return false;
        }
        return true;
    }

    const addWishlistedProfile = (email) => {
        if (!checkIfLoggedIn()) return;
        Mixpanel.track(Constants.Mixpanel.RECRUITER_CANDIDATE_PROFILE_SHORTLIST_ADDED);
        dispatch(addRecruiterWishlist(recruiterAccessToken, email, (response) => {
            setIsWishlistedLocal(true);
            console.log(response);
        }, (error) => {
            console.log(error);
        }));
    }
    const removeWishlistedProfile = (email) => {
        if (!checkIfLoggedIn()) return;
        Mixpanel.track(Constants.Mixpanel.RECRUITER_CANDIDATE_PROFILE_SHORTLIST_REMOVED);
        dispatch(removeRecruiterWishlist(recruiterAccessToken, email, (response) => {
            setIsWishlistedLocal(false);
            console.log(response);
        }, (error) => {
            console.log(error);
        }));
    }

    const getUserProfileByEmail = (email) => {
        Mixpanel.track(Constants.Mixpanel.RECRUITER_RESULTS_PAGE_TOP_CANDIDATE_PROFILE_CARD_CLICKED);
        if (!checkIfLoggedIn()) return;
        setIsFetchingFullProfile(true);
        dispatch(getProfileByEmail(email, (response) => {
            console.log(response?.profile);
            setFullProfile(response?.profile);
            setIsFetchingFullProfile(false);
            setIsProfileModalOpen(true);
        }, (error) => {
            console.log(error);
            setIsFetchingFullProfile(false);
        }));
    };

    const renderProfileCard = (card, index) => {
        return (
            <div
                index={index}
                onClick={() => getUserProfileByEmail(card?.id_email)}
                className="flex w-[156px] flex-col items-center justify-between rounded-2xl border border-gray-200/20 px-3 pt-3 pb-3 shadow-sm"
                style={{
                    WebkitTapHighlightColor: "transparent",
                    background:
                        "radial-gradient(50% 50% at 50% 22%, rgba(246, 204, 152, 0.4) 0%, rgba(246, 204, 152, 0) 100%), linear-gradient(0deg, rgba(7, 19, 29, 1) 0%, rgba(7, 19, 29, 1) 100%)",
                }}>
                <div
                    className="relative flex h-[108px] w-full cursor-pointer flex-col items-center justify-between self-stretch"
                >

                    <div className="absolute z-[1] flex w-full flex-row items-start justify-between gap-2.5 self-stretch px-0 pt-2 pb-0">
                        <div className="mb-2 flex items-start justify-between">
                            <div className="flex flex-col items-center">
                                <div className="relative">
                                    <div
                                        className="relative z-10 flex items-start justify-start rounded-lg text-2xl font-extrabold text-[#F7E394] shadow-lg"
                                    >
                                        {card?.match_score}
                                    </div>
                                    {card?.match_score && <div className="w-full h-[15px] mt-1 gap-0.5 whitespace-nowrap text-[8px] font-sans bg-[#fff] text-[#000] rounded-lg px-1 text-center flex items-center justify-center">
                                        {card?.match_score ? "Match Score" : ""}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="relative inline-flex flex-shrink-0 items-center justify-center gap-0.5"
                            style={{ WebkitTapHighlightColor: "transparent" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                isWishlistedLocal ? removeWishlistedProfile(card?.id_email) : addWishlistedProfile(card?.id_email)
                            }}>
                            <img src={`${isWishlistedLocal ? "https://assets.learntube.ai/files/halloffame/recruiter/Button%20(1).svg" : "https://assets.learntube.ai/files/halloffame/recruiter/Button.svg"}`} alt="shortlist" className="h-9 w-9 text-white" />
                        </div>
                    </div>
                    {card?.profile_photo ? (
                        <img
                            className="relative z-0 mt-8 h-[88px] w-[88px] rounded-[100px] object-cover"
                            alt="profile"
                            src={card?.profile_photo}
                        />
                    ) : (
                        <div className="relative z-0 mt-8 flex h-[80px] w-[80px] items-center justify-center rounded-full bg-[#283b4a] text-[28px] font-bold uppercase text-[#F7E394]">
                            {getInitials(card?.profile?.full_name)}
                        </div>
                    )}
                </div>

                <div className="relative mt-2 flex w-full flex-[0_0_auto] flex-col items-start gap-2 self-stretch">
                    <div className="relative flex w-full flex-[0_0_auto] flex-col items-start gap-2 self-stretch">
                        <div className="relative flex w-full flex-[0_0_auto] flex-col items-start self-stretch">
                            <div className="relative mt-[-1.00px] self-stretch font-sans text-[10px] font-normal leading-[10px] tracking-[0] text-white">
                                <span className={`text-left font-inter text-[14px] font-bold leading-[18px] tracking-[0px] line-clamp-2 text-white cursor-pointer mt-2 ${card?.experience?.job_title ? 'mb-0' : 'mb-2'}`}>
                                    {card?.profile?.full_name?.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())}
                                </span>
                                <span className="text-left font-inter text-[12px] font-bold leading-[18px] tracking-[0px] line-clamp-2 text-[#A7B6C2] mb-2 cursor-pointer">
                                    {card?.individual_scores?.evidence_breakdown?.experience_evidence?.length === 0 && card?.individual_scores?.evidence_breakdown?.profile_evidence?.primary_found?.length > 0 ? 'Top skills:' + card?.individual_scores?.evidence_breakdown?.profile_evidence?.primary_found[0] + card?.individual_scores?.evidence_breakdown?.profile_evidence?.primary_found[1] : card?.experience?.job_title === card?.individual_scores?.evidence_breakdown?.experience_evidence?.[0]?.job_title ? card?.experience?.job_title : card?.individual_scores?.evidence_breakdown?.experience_evidence?.[0]?.job_title === '' || !card?.individual_scores?.evidence_breakdown?.experience_evidence?.[0]?.job_title ? card?.experience?.job_title : 'Ex: ' + card?.individual_scores?.evidence_breakdown?.experience_evidence?.[0]?.job_title}
                                </span>
                                <span className="text-left font-inter text-[12px] font-normal leading-[18px] tracking-[0px] line-clamp-1 text-[#A7B6C2] cursor-pointer">
                                    {card?.experience?.company_name === 'Not Specified' ? '' : card?.experience?.company_name === 'Not specified' ? '' : card?.experience?.company_name}
                                </span>
                                {card?.additional_profile_info?.total_experience_months !== null && <span className="text-left font-inter text-[12px] font-normal leading-[18px] tracking-[0px] line-clamp-1 text-[#A7B6C2] cursor-pointer"> Exp: {card?.additional_profile_info?.total_experience_months === 0 ? 'Fresher' : (card?.additional_profile_info?.total_experience_months > 12 ? `${Math.floor(card?.additional_profile_info?.total_experience_months / 12)}+ years` : `${card?.additional_profile_info?.total_experience_months} months`)}
                                </span>}
                            </div>
                            {card?.top_skill && <div className="relative flex flex-row items-center justify-center gap-1 self-stretch font-sans text-[10px] font-normal leading-[15px] tracking-[0px] text-[#a7b6c2] mt-4">
                                <img src="https://assets.learntube.ai/files/halloffame/recruiter/hugeicons_laurel-wreath-left-01.svg" alt="left design" srcset="" />
                                <span className="text-center font-inter text-[10px] font-bold leading-[15px] tracking-[0px] line-clamp-3 text-[#F7E394]">
                                    {card?.top_skill}
                                </span>
                                <img src="https://assets.learntube.ai/files/halloffame/recruiter/hugeicons_laurel-wreath-right-01.svg" alt="right decoration" srcset="" />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {renderProfileCard(candidates, key)}
            {isProfileModalOpen && <ProfileModal fullProfile={fullProfile} matchScore={matchScore} setIsProfileModalOpen={setIsProfileModalOpen} isFetchingFullProfile={isFetchingFullProfile} isWishlistedLocal={isWishlistedLocal} addWishlistedProfile={addWishlistedProfile} removeWishlistedProfile={removeWishlistedProfile} />}
        </>
    )
}

export default CandidatesCard